<!--
	用法:
        this.$store.commit('showLoading', true);

 -->

<template>
	<div class="loading">
		<div class="loading-layer"></div>
		<img src="../../assets/images/common/data-loading.gif">
	</div>
</template>

<script>
	export default{
	  mounted(){
		
	  }		
	}
</script>

<style>
	.loading-layer{
		height: 100%;
		width: 100%;
	}
	.loading{
		width: 100%;
		height: 100%;
		position: relative;
		top:-100%;
		z-index: 100;
		left: 0px;
		border-radius: 0!important;
		background-color:rgba(0,0,0,0)!important;
		padding:0!important;
		
	}
	.loading .loading-layer{
		background-color: rgba(0,0,0,0.2);
	}
	.loading img{
		position: absolute;
		left:0;
		top:0;
		bottom: 0;
		right: 0;
		margin: auto;
		z-index: 101;
	}
</style>
